import axios from 'axios';

const API_BASE_URL = 'https://www.xiaoliangtongxue.cn/api';

// Create and configure axios instance
const instance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    withCredentials: true
});

export const orderApi = {
    // 获取订单列表
    getOrders(userId = null) {
        const params = userId ? { user_id: userId } : {};
        return instance.get('/order', { params });
    },

    // 创建订单
    createOrder(orderData) {
        return instance.post('/order', orderData);
    },

    // 取消订单
    cancelOrder(orderId) {
        return instance.put(`/order/${orderId}`, {
            state: 'cancelled'
        });
    },

    // 下载文件
    downloadFile(fileId) {
        return instance.get(`/download/${fileId}`, {
            responseType: 'blob'
        });
    }
};

export const userApi = {
    // 获取用户列表
    getUsers() {
        return instance.get('/users');
    },

    // 删除用户
    deleteUser(userId) {
        return instance.delete(`/users/${userId}`);
    },
    getPoorApplications() {
        return instance.get('/users/poor');
    },
    downloadPoorFile(userId) {
        return instance.get(`/download-poor-file/${userId}`, { responseType: 'blob' });
    },
    approvePoorApplication(userId) {
        return instance.put(`/poor/${userId}`);
    },
    rejectPoorApplication(userId) {
        return instance.put(`/reject/${userId}`);
    },
};

// Export the configured axios instance as default
export default instance; 